import * as Actions from './';

export function displayNotice(body, options) {
  console.error('DEPRETIATION NOTICE: Please do not use the displayNotice() action. Use notify() instead. See actions/error.js')
	// calling the function should be done in the following format, for example:
	// ({message : 'Hey this is an error'}, {type : error, style : danger, position : stack-topleft})
	if (options)
	{
		var stack_topleft = {"dir1": "down", "dir2": "right", "push": "top"};
		var stack_bottomleft = {"dir1": "right", "dir2": "up", "push": "top"};
		var stack_bottomright = {"dir1": "up", "dir2": "left", "firstpos1": 15, "firstpos2": 15};
		var stack_bar_top = {"dir1": "down", "dir2": "right", "push": "top", "spacing1": 0, "spacing2": 0};
		var stack_bar_bottom = {"dir1": "up", "dir2": "right", "spacing1": 0, "spacing2": 0};

		var title = options.type;
		if(title)
			title = title.replace(new RegExp(title[0]), title[0].toUpperCase(), 1);
		var config = {
		    title,
		    text: body.message,
		    type: options.type,
		    addclass: 'notification-' + options.style + ' ' + options.position,
		    icon: 'fa fa-exclamation-circle',
		}

		switch(options.position) {
			case 'stack-bar-top':
				config.stack = stack_topleft;
				config.width = "100%";
				break;
			case 'stack-bottomleft':
				config.stack = stack_bottomleft;
				break;
			case 'stack-bottomright':
				config.stack = stack_bottomright;
				break;
			case 'stack-bar-bottom':
				config.stack = stack_bar_bottom;
				break;
			case 'stack-topleft':
				config.stack = stack_topleft;
				break;
			default:
				config.stack = stack_topleft;
				console.warn('You did not specify a valid position type.','stack-bar-top',
					'stack-bottomleft',
					'stack-bottomright',
					'stack-bar-bottom',
					'stack-topleft' );
				break;
		}

		new PNotify(config);
	}

	else {
			new PNotify({
			    title: 'Error: ',
			    text: body.message,
			    type: 'error',
			    addclass: 'notification-danger stack-topleft',
			    icon: 'fa fa-exclamation-circle',
			    stack : stack_topleft
			});
	}
}

const stack_bar_top = {"dir1": "down", "dir2": "right", "push": "top", "spacing1": 0, "spacing2": 0};

export const notify = (error, settings = {

}) => {
  return (dispatch) => {
    let icon;

    switch(settings.type) {
      case 'info':
        icon = 'fa fa-info';
        break;
      case 'success':
        icon = 'fa fa-check-circle';
        break;
      case 'warning':
        icon = 'fa fa-exclamation-triangle';
        break;
      case 'danger':
      default:
        icon = 'fa fa-times-circle';
        break;
    }

    new PNotify({
      title: error.title || 'Error!',
      text: error.message,
      type : settings.type || 'error',
      addclass: settings.class || 'stack-bar-top',
      icon: settings.icon || icon,
      stack: stack_bar_top,
      width: settings.width || "100%"
    });
  }
}



// WEBPACK FOOTER //
// ./src/common/actions/error.js